import React from "react";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBIcon } from "mdb-react-ui-kit";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import "./ToggleablePieCard.css";

const PIE_COLORS = ["#1266f1", "#00bfa5", "#ff7043", "#ab47bc", "#ffa000", "#26c6da", "#8d6e63", "#ef5350"];

export class ToggleablePieCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hiddenCategories: new Set(),
    };
    this.toggleCategory = this.toggleCategory.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ hiddenCategories: new Set() });
    }
  }

  toggleCategory(categoria) {
    this.setState((prev) => {
      const next = new Set(prev.hiddenCategories);
      if (next.has(categoria)) {
        next.delete(categoria);
      } else {
        next.add(categoria);
      }
      return { hiddenCategories: next };
    });
  }

  formatCurrency(value) {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
    }).format(value ?? 0);
  }

  render() {
    const { title, data = [], emptyText = "Sin datos." } = this.props;
    const { hiddenCategories } = this.state;

    const allData = data.filter((x) => Number(x.total) > 0);
    const visibleData = allData.filter((x) => !hiddenCategories.has(x.categoria));

    return (
      <MDBCard className="h-100">
        <MDBCardBody className="d-flex flex-column">
          <MDBCardTitle className="dashboard-section-title">
            <MDBIcon fas icon="chart-pie" className="me-2" />
            {title}
          </MDBCardTitle>

          {allData.length === 0 ? (
            <p className="text-muted text-center py-3 mb-0">{emptyText}</p>
          ) : (
            <div className="tpc-wrapper flex-grow-1">
              {/* Pie chart */}
              {visibleData.length > 0 ? (
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={visibleData}
                      dataKey="total"
                      nameKey="categoria"
                      cx="50%"
                      cy="50%"
                      outerRadius={100}
                      labelLine={false}
                      label={({ percent }) =>
                        percent > 0.06 ? `${Math.round(percent * 100)}%` : ""
                      }
                    >
                      {visibleData.map((entry) => {
                        const originalIdx = allData.findIndex(
                          (d) => d.categoria === entry.categoria
                        );
                        return (
                          <Cell
                            key={`cell-${entry.categoria}`}
                            fill={PIE_COLORS[originalIdx % PIE_COLORS.length]}
                          />
                        );
                      })}
                    </Pie>
                    <Tooltip formatter={(v) => this.formatCurrency(v)} />
                  </PieChart>
                </ResponsiveContainer>
              ) : (
                <div className="tpc-all-hidden">
                  <MDBIcon fas icon="eye-slash" className="me-2 text-muted" />
                  <span className="text-muted">
                    Todas las categorías están ocultas.
                    <br />
                    Haz clic en la leyenda para mostrarlas.
                  </span>
                </div>
              )}

              {/* Leyenda interactiva */}
              <div className="tpc-legend">
                {allData.map((entry, index) => {
                  const hidden = hiddenCategories.has(entry.categoria);
                  return (
                    <div
                      key={entry.categoria}
                      className={`tpc-legend-item${hidden ? " tpc-hidden" : ""}`}
                      onClick={() => this.toggleCategory(entry.categoria)}
                      title={hidden ? "Haz clic para mostrar" : "Haz clic para ocultar"}
                    >
                      <span
                        className="tpc-dot"
                        style={{
                          backgroundColor: hidden
                            ? "#ccc"
                            : PIE_COLORS[index % PIE_COLORS.length],
                        }}
                      />
                      <span className="tpc-label">{entry.categoria}</span>
                      <span className="tpc-value">
                        {this.formatCurrency(entry.total)}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </MDBCardBody>
      </MDBCard>
    );
  }
}
